<template>
  <div></div>
</template>

<script>
export default {
  name: 'MigrisWeb',
  created() {
    this.migrisRedirect()
  },
  methods: {
    migrisRedirect() {
      const migrisWebUrl = process.env.VUE_APP_MIGRIS_WEB_URL
      if (migrisWebUrl) {
        window.location.href = migrisWebUrl
        return
      }

      this.$router.push({ name: 'home' })
    },
  },
}
</script>
